import MainNavbar from "../components/reuse/navbar";

export default function FactorsReportsPage(){
    return(
         <>
            <div>
                <MainNavbar/>
            </div>
            <div className="block">
                <h1>Страница с факторным отчётом</h1>
            </div>
        </>
    )
}